import { type RelayRefetchProp } from 'react-relay';
import { type RefetchFn } from '../types/layoutRefetch.ts';

import { type SbRespCreatorsLayoutRefetchQuery$variables } from '../SbRespCreatorsLayout/__generated__/SbRespCreatorsLayoutRefetchQuery.graphql.ts';
import { type SbMobileCreatorsLayoutRefetchQuery$variables } from '../SbMobileCreatorsLayout/__generated__/SbMobileCreatorsLayoutRefetchQuery.graphql.ts';

type RefetchVariables = Partial<
    (SbRespCreatorsLayoutRefetchQuery$variables | SbMobileCreatorsLayoutRefetchQuery$variables) & {
        afterDisplay: boolean;
    }
>;

export const handleUserRefetch = (
    relay: RelayRefetchProp,
    setIsClient: (isClient: boolean) => void
): RefetchFn<RefetchVariables> => {
    return (variables, renderVariables, callback) => {
        const isClient = variables?.afterDisplay === true;
        setIsClient(isClient);
        /**
         * Only set variables that are directly used by the `SbRespCreatorsLayoutRefetchQuery` and `
         * SbMobileCreatorsLayoutRefetchQuery`queries.
         */
        const { userId, fetchUser, followSearchTypes, followSearchPages } = variables;
        relay.refetch(
            {
                userId,
                fetchUser,
                followSearchTypes,
                followSearchPages,
                isClient,
            },
            renderVariables,
            callback
        );
    };
};
